import { Box, Typography } from "@mui/material";
import React from "react";

const Header = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "20px", sm: "25px", md: "40px" },
          lineHeight: "40px",
          fontWeight: "700",
        }}
        className="text-textColor dark:text-darkTextColor"
      >
        Add Your Own Panel
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
        className="text-textColor dark:text-darkTextColor"
      >
        add your panel to our database that makes your services reachable and
        your clients increase over time.
      </Typography>
    </Box>
  );
};

export default Header;
